import React, { useEffect, useState } from "react";
import { navigate } from 'gatsby';
import PropTypes from "prop-types";
import Fade from 'react-reveal/Fade';
import Header from "~/components/header";
import FooterComponent from "~/components/footer";
import NavigatorBottomComponent from "~/components/navigationBottom";
import PlayUrlContext from "~/context/play-url";
import GlobalStyle from "~/styles/js/global";
import Navbar from "./navbar";
import FloatQrComponent from "~/components/floatqr";
import live22Bg from "~/images/bg_live22.png";
import slotxoBg from "~/images/bg_slotxo.png";
import pgslotBg from "~/images/bg_pgslot.png";
import jokerBg from "~/images/bg_joker.png";
import ambslotBg from "~/images/bg_ambslot.png";
import SEO from "../components/seo";
import { Helmet } from 'react-helmet';
import { useLocation } from "@reach/router";

const Layout = ({ children, pageName }) => {
  const [isFloatQr, setFloatQr] = useState(true);
  const toggleIsFloatQr = () => setFloatQr(false);
  const bgground = {
    live22: live22Bg,
    slotxo: slotxoBg,
    pgslot: pgslotBg,
    joker: jokerBg,
    ambslot: ambslotBg
  }

  const router = useLocation();

  const isHomePage = !!['/', '/slotxo', '/pgslot', '/joker'].includes(router.pathname)

  useEffect(() => {
    const checkQUery = () => {
      if (router.pathname.includes('/ambslot')) navigate('/');;
    }
    checkQUery()
  }, [])

  return (
    <PlayUrlContext.Consumer>
      {() => (
        <div className="relative"
          style={{ background: `url(${bgground[pageName]})` }}
        >
          <SEO lang="th" />
          <Helmet>
            <script language="JavaScript" src="https://livechats.goochat.net/livechat.js?n=1"></script>
            <link rel="stylesheet" type="text/css" href="https://livechats.goochat.net/style.css?v=1" />
          </Helmet>
          <GlobalStyle isHomePage={isHomePage} />
          <Helmet>
            <body
              className="new-class-for-body"
              onload="chat('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjcmVhdGVkVGltZSI6IjIwMjItMTEtMDMgMDk6MzU6NTQiLCJvYUlkIjoiNjM2MzhiN2FjM2RjNTdhYmY1Nzc2ZGJmIn0.ftaVdmHdQIeW1dOgGxPV5JnMfRHr7mZeZqKjqZDyfFU')"
            />
          </Helmet>
          <Header />
          <Navbar />
          <main>
            {children}
          </main>
          <Fade bottom>
            <FooterComponent />
          </Fade>
          <NavigatorBottomComponent />
          {(isFloatQr && !isHomePage) && (
            <FloatQrComponent toggleIsFloatQr={toggleIsFloatQr} />
          )}
        </div>
      )
      }
    </PlayUrlContext.Consumer >
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
